import { useQuery } from "@apollo/client/react";
import GET_CLIENT_MANUAL_RULES from "../../queries/aml/getClientManualRules";

export type ManualRuleItem = {
  isEditable: boolean;
  ruleType: string;
  selectableValues?: {
    title: string;
    value: boolean;
  }[];
};

type ManualRuleResponse = {
  client: {
    id: string;
    riskScore: {
      manualRules: ManualRuleItem[];
    };
  };
};

export const useClientManualRules = (id: string) => {
  const { data, error, loading, refetch } = useQuery<ManualRuleResponse>(
    GET_CLIENT_MANUAL_RULES,
    {
      variables: { identifier: id },
    }
  );
  return {
    rules: data?.client?.riskScore?.manualRules,
    error,
    loading,
    refetch,
  };
};
